export default "__VITE_ASSET__DwQe4Knp__"